import JoditEditor from 'jodit-react';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavMenu } from '../components/NavMenu';
import DualBallSpinner from '../img/dual-ball-1s-100px.gif';
import HideHelp from '../img/help-close-icon.png';
import ShowHelp from '../img/help-icon.png';
import { businessIdHeader, cssError, cssFormInput, cssFormInputButton, cssFormInputFile, cssFormInputLabel, cssFormInputText, fetchSignedMessage, fileFieldType, getSessionValue, httpOKsuccess, isLoggedIn, notificationBodyLength, notificationTitleLength, postAttachment, postMethod, textField } from './Library';


export class BusinessOption {
	constructor(key, value, text) {
		this.text = text;
		this.key = key;
		this.value = value;
	}
}

export class MessageSender extends Component {

	constructor(props) {
		super(props)
		this.state = {
			businessId: '',
			title: '',
			description: '',
			attachmentPath: '',
			timeToSend: null,
			attachment: null,
			messageLink: '',
			htmlMessage: '',
			loading: true,
			errorDescription: '',
			errorTitle: '',
			helpVisible: false,
			sumbitButtonDisabled: false,
			recipients: props.recipients
		};
		this.handleInputChange = this.handleInputChange.bind(this);
	}

	async componentDidMount() {
		await isLoggedIn();
		this.setState({ loading: false });
	}

	setDateControlToCurrentDateTime(fieldIdentifier) {
		var tzoffset = (new Date()).getTimezoneOffset() * 60000; //offset in milliseconds
		var localISOTime = (new Date(Date.now() - tzoffset)).toISOString().slice(0, -1);
		var localISOTimeWithoutSeconds = localISOTime.slice(0, 16);

		var datePicker = document.querySelector('input[name=' + fieldIdentifier + ']');
		datePicker.value = localISOTimeWithoutSeconds;
		this.setState({
			[fieldIdentifier]: localISOTimeWithoutSeconds
		})
	}

	handleInputChange = (event) => {
		const target = event.target;
		if (target == undefined) {
			this.setState({ 'htmlMessage': event });
		} else {
			const value = target.type === 'checkbox' ? target.checked : target.type === 'number' ? parseInt(target.value) : target.value;
			const name = target.name;

			this.setState({
				[name]: value
			});
		}
	}

	handleDropDownChange = (e, data) => {
		const name = data.name;
		this.setState({
			[name]: data.value
		})
	}

	handleFileChange = (event) => {
		this.setState({
			attachment: event.target.files[0]
		})
	}


	handleSubmit = async (event) => {
		const isValid = this.handleValidation();
		if (isValid) {

			var responseLabel = document.getElementById("messageSentResponse");

			this.setState({ loading: true, sumbitButtonDisabled: true });
			ReactDOM.render('', responseLabel)
			const messageData = {
				title: this.state.title,
				description: this.state.description,
				businessid: getSessionValue(businessIdHeader),
				messageLink: this.state.messageLink
			};

			if (this.state.recipients != null) {
				messageData.consumerDevicesToSendMessagesTo = [];
				for (var i = 0; i < this.state.recipients.length; i++) {
					const messageDeviceRecipient = { consumerDeviceId: this.state.recipients[i] }
					messageData.consumerDevicesToSendMessagesTo.push(messageDeviceRecipient);
				}
			}

			if (this.state.attachment != null) {
				this.state.attachmentPath = postAttachment(this.state.attachment);
				messageData.attachmentPath = 'https://' + process.env.REACT_APP_MESSAGE_BUCKET_NAME + '.s3.' + process.env.REACT_APP_AWS_REGION + '.amazonaws.com/' + this.state.attachmentPath;
			}

			if (this.state.timeToSend != null) {
				messageData.timeToSend = this.state.timeToSend;
			}

			if (this.state.htmlMessage != null) {
				messageData.htmlMessage = this.state.htmlMessage;
			}

			fetchSignedMessage(JSON.stringify(messageData), 'message', postMethod).then(response => {
				if (response.status == httpOKsuccess) {
					ReactDOM.render(<label className={cssFormInputLabel}>Message sent succesfully.</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				} else {
					ReactDOM.render(<label className={cssFormInputLabel}>Message sending failed. Please try again later.</label>, responseLabel);
					this.setState({ loading: false, sumbitButtonDisabled: false });
				}
			}).catch(error => {
				this.setState({ loading: false, sumbitButtonDisabled: false });
				ReactDOM.render(<label className={cssFormInputLabel}>Message sending failed. Please try again later.</label>, responseLabel)
			});

		}
		event.preventDefault();
	}

	finishLoading = () => {
		this.setState({ loading: false })
	}

	handleValidation() {
		let validated = true;

		if (!this.validateTextContainsText(this.state.description, "errorDescription", "A message requires a description")) {
			validated = false;
		}

		if (!this.validateTextContainsText(this.state.title, "errorTitle", "A message requires a title")) {
			validated = false;
		}

		return validated;
	}

	validateTextContainsText(valueToValidate, stateForErrorMessage, errorMessage) {
		if (valueToValidate.length == 0) {
			this.setState({ [stateForErrorMessage]: errorMessage });
			return false;
		} else {
			this.setState({ [stateForErrorMessage]: "" });
			return true;
		}
	}

	toggleHelp = (event) => {
		this.setState({
			helpVisible: !this.state.helpVisible
		});
	}

	render() {

		return (
			<>
				<div>
					<form onSubmit={this.handleSubmit} className={cssFormInput} >

						<label className={cssFormInputFile} >
							Title:
							<input tabIndex={1} type={textField} className={cssFormInputText} name="title" value={this.state.title} onChange={this.handleInputChange} maxLength={notificationTitleLength} />
						</label>{this.state.errorTitle && <p className={cssError} >{this.state.errorTitle}</p>}

						<label className={cssFormInputFile} >
							Description:
							<input tabIndex={2} type={textField} className={cssFormInputText} name="description" value={this.state.description} onChange={this.handleInputChange} maxLength={notificationBodyLength} />
						</label>{this.state.errorDescription && <p className={cssError} >{this.state.errorDescription}</p>}

						<label className={cssFormInputFile}>
							HTML Message:
							<JoditEditor
								value={this.state.htmlMessage}
								onBlur={this.handleInputChange}
								editorClassName={cssFormInputText}
								tabIndex={3}

							/>
						</label>
						<script>alert("this is happening");
							const htmlMessage = Jodit.make('#htmlMessage');</script>

						<label className={cssFormInputFile}>
							Attachment:
							<input tabIndex={4} type={fileFieldType} name="attachment" onChange={this.handleFileChange} className={cssFormInputFile} /><br />
						</label>

						<label className={cssFormInputFile}>
							Click through link:
							<input tabIndex={5} type={textField} className={cssFormInputText} name="messageLink" value={this.state.messageLink} onChange={this.handleInputChange} /><br />
						</label>

						<label className={cssFormInputLabel}>
							Time to send message (leave blank if sending now):
							<input tabIndex={6} type="datetime-local" name="timeToSend" value={this.state.timeToSend} onChange={this.handleInputChange} className={cssFormInputText} />
						</label>

						<input tabIndex={7} type="submit" className={cssFormInputButton} value="Send Message" disabled={this.state.sumbitButtonDisabled} />
						<img src={this.state.helpVisible ? HideHelp : ShowHelp} className="btn-help" onClick={this.toggleHelp} />

					</form>
				</div>
				{this.state.loading ? <img src={DualBallSpinner} alt="Loading" /> : ''}
				<div id="messageSentResponse" />
			</>
		);
	}
}
